import { BACKEND_ROLES } from "../constants/backendRoles";
import type { RoutePermission } from "../types/auth.types";

const {
  ADMIN,
  COMPANY_ADMIN,
  MANAGER,
  EXECUTIVE,
  PRE_SALES,
  HR,
  EMPLOYEE,
} = BACKEND_ROLES;

/**
 * Central route permission registry using exact backend role strings.
 */
export const ROUTE_PERMISSIONS: RoutePermission[] = [
  // ── Dashboard ──────────────────────────────────────────────────────────────
  {
    path: "/dashboard",
    label: "Dashboard",
    showInMenu: true,
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, PRE_SALES, EMPLOYEE],
  },

  // ── HR ─────────────────────────────────────────────────────────────────────
  {
    path: "/hr/users",
    label: "Employee Master",
    allowedRoles: [ADMIN, COMPANY_ADMIN, HR],
  },
  {
    path: "/hr/create-user",
    allowedRoles: [ADMIN, COMPANY_ADMIN, HR],
  },
  {
    path: "/hr/view/:userId",
    allowedRoles: [ADMIN, COMPANY_ADMIN, HR],
  },
  {
    path: "/hr/edit/:id",
    allowedRoles: [ADMIN, COMPANY_ADMIN, HR],
  },

  // ── Sales ──────────────────────────────────────────────────────────────────
  {
    path: "/:vertical/inquiries",
    label: "Sales",
    showInMenu: true,
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, PRE_SALES, EMPLOYEE],
  },
  {
    path: "/:vertical/inquiries/create",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, PRE_SALES, EMPLOYEE],
  },
  {
    path: "/:vertical/inquiries/:id/edit",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, PRE_SALES, EMPLOYEE],
  },
  {
    path: "/:vertical/inquiries/:id/view",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, PRE_SALES, EMPLOYEE],
  },
  {
    path: "/inquiries/recycle-bin",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER],
  },
  {
    path: "/:vertical/followups",
    label: "Sales Followup",
    showInMenu: true,
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, PRE_SALES, EMPLOYEE],
  },
  {
    path: "/:vertical/followups/:id/edit",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, PRE_SALES, EMPLOYEE],
  },

  // ── Masters ────────────────────────────────────────────────────────────────
  {
    path: "/masters/client",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, PRE_SALES, EMPLOYEE],
  },
  {
    path: "/masters/contact",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, PRE_SALES, EMPLOYEE],
  },
  {
    path: "/payment-terms",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, EMPLOYEE],
  },
  {
    path: "/stage",
    allowedRoles: [ADMIN, COMPANY_ADMIN],
  },
  {
    path: "/stage/create",
    allowedRoles: [ADMIN, COMPANY_ADMIN],
  },
  {
    path: "/stage/view/:id",
    allowedRoles: [ADMIN, COMPANY_ADMIN],
  },
  {
    path: "/stage/edit/:id",
    allowedRoles: [ADMIN, COMPANY_ADMIN],
  },
  {
    path: "/bulk-transfer",
    allowedRoles: [ADMIN, COMPANY_ADMIN],
  },

  // ── Reports ────────────────────────────────────────────────────────────────
  {
    path: "/:vertical/reports",
    label: "Reports",
    showInMenu: true,
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, EMPLOYEE],
  },
  {
    path: "/reports/contact-directory",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, EMPLOYEE],
  },
  {
    path: "/reports/contact-directory-assigned-to",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, EMPLOYEE],
  },
  {
    path: "/reports/contact-directory-created-by",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, EMPLOYEE],
  },
  {
    path: "/:vertical/reports/not-attended-30-days",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, EMPLOYEE],
  },
  {
    path: "/timelag-report",
    allowedRoles: [ADMIN, COMPANY_ADMIN],
  },

  // ── Settings ───────────────────────────────────────────────────────────────
  {
    path: "/company",
    label: "Company Details",
    allowedRoles: [ADMIN, COMPANY_ADMIN],
  },
  {
    path: "/company/settings",
    label: "Time Lag",
    allowedRoles: [ADMIN, COMPANY_ADMIN],
  },
  {
    path: "/settings",
    label: "Settings",
    allowedRoles: [ADMIN, COMPANY_ADMIN],
  },
  {
    path: "/profile",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, PRE_SALES, HR, EMPLOYEE],
  },
];
